import './App.css';
import Intro from './Component/Intro';
import Body from './Component/Body';
import Footer from './Component/Footer';

function App() {
  return (
  
    <div>
      <Intro />
      <Body />
      <Footer />
    </div>
  );
}


export default App;
